import { render, staticRenderFns } from "./FormQuestion.vue?vue&type=template&id=730a7d69&"
import script from "./FormQuestion.vue?vue&type=script&lang=js&"
export * from "./FormQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports